<div fileDrop
     [ngClass]="{'file-is-over my-drop-zone': fileIsOver && ds.path.length > 0}"
     [options]="options"
     (drop)="ds.path.length > 0 && onFileDrop($event)"
     (fileOver)="ds.path.length > 0 && fileOver($event)">
    <div class="table-responsive" [class.overflow-hidden]="ds.emptyRowService.emptyRow.length > 0">
        <table class="table table-striped table-hover documents-list-table footable"
               *ngIf="documentsList && documentsList.length">
            <thead>
                <tr [ngClass]="{'noSort': documentsList.length < 2}">
                    <th *ngIf="!authenticationService.userIsResident"></th>
                    <th (click)="orderBy('name', $event)" class="footable-sorted">
                        Name <span class="footable-sort-indicator"></span>
                    </th>
                    <th *ngIf="!authenticationService.userIsResident && ds.buildings.length > 1">Buildings</th>
                    <th *ngIf="!authenticationService.userIsResident">Resident Access</th>
                    <th *ngIf="!authenticationService.userIsResident">Group Access</th>
                    <th *ngIf="!authenticationService.userIsResident" (click)="orderBy('public', $event)">
                        Public Access <span class="footable-sort-indicator"></span>
                    </th>
                    <th *ngIf="authenticationService.userIsResident"
                        (click)="orderBy('size', $event)" [ngStyle]="{'width': 5 + '%'}">
                        Size <span class="footable-sort-indicator"></span>
                    </th>
                    <th (click)="orderBy('createdAt', $event)">Date <span class="footable-sort-indicator"></span></th>
                    <th (click)="orderBy('createdBy', $event)" [ngStyle]="{'width': 10 + '%'}">
                        From <span class="footable-sort-indicator"></span>
                    </th>
                    <th *ngIf="authenticationService.userIsResident"></th>
                </tr>
            </thead>
            <tbody>
                <tr document-item
                    (click)="!authenticationService.userIsResident ? ds.toggleDetailedView(item) : true"
                    *ngFor="let item of documentsList; trackBy: trackByFn; let index = index;"
                    [ngClass]="{'footable-odd': (index % 2 === 0)}"
                    [data]="item">
                </tr>

                <tr *ngFor="let item of ds.emptyRowService.emptyRow" class="empty-row">
                    <td *ngIf="!authenticationService.userIsResident"></td>
                    <td></td>
                    <td *ngIf="!authenticationService.userIsResident && ds.buildings.length > 1"></td>
                    <td *ngIf="!authenticationService.userIsResident"></td>
                    <td *ngIf="!authenticationService.userIsResident"></td>
                    <td *ngIf="!authenticationService.userIsResident"></td>
                    <td *ngIf="authenticationService.userIsResident"></td>
                    <td></td>
                    <td></td>
                    <td *ngIf="authenticationService.userIsResident"></td>
                </tr>
            </tbody>
        </table>

        <empty-result-message
                [isEmpty]="!(documentsList?.length)"
                [isLoading]="ds.isDocumentsLoading">
            You have no documents listed on the system<br>
            <span *ngIf="!authenticationService.userIsResident && (!ds.path[0] || (ds.path[0] && ds.path[0].isCanEdit))">
                <a href="javascript://" (click)="ds.showUploadFileModal()" class="mtv-primary-color clickable-text">add a file</a> now
            </span>
        </empty-result-message>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/documents/documents-list/documents-list.component.html